var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ContactProfile" } },
    [
      !_vm.$store.state.chat.isMobileMode
        ? _c(
            "div",
            {
              staticClass: "panel panel-default",
              staticStyle: { "margin-bottom": "unset" },
              attrs: { id: "SearchContact" }
            },
            [
              _c("div", { staticClass: "panel-heading web-ui" }),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c("input", {
                      staticClass: "search-ui",
                      attrs: {
                        type: "text",
                        name: "search",
                        placeholder: "Search for customers name...",
                        autocomplete: "off"
                      },
                      on: {
                        keyup: [
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.sendSearch($event)
                          },
                          function($event) {
                            if (
                              $event.ctrlKey ||
                              $event.shiftKey ||
                              $event.altKey ||
                              $event.metaKey
                            ) {
                              return null
                            }
                            return _vm.chekSearch($event)
                          }
                        ]
                      }
                    })
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.chat.isMobileMode
        ? _c("div", { staticClass: "search-contact" }, [
            _c("input", {
              staticClass: "search-ui",
              attrs: {
                type: "text",
                name: "search",
                placeholder: "Search for customers name...",
                autocomplete: "off"
              },
              on: {
                keyup: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.sendSearch($event)
                  },
                  function($event) {
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    ) {
                      return null
                    }
                    return _vm.chekSearch($event)
                  }
                ]
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header-group" }, [_vm._v("Profile")]),
      _vm._v(" "),
      _c("div", { staticClass: "uk-card uk-card-default" }, [
        _c("div", { staticClass: "uk-card-header" }, [
          _c(
            "div",
            {
              staticClass: "uk-grid-small uk-flex-middle",
              attrs: { "uk-grid": "" }
            },
            [
              _c("div", { staticClass: "uk-width-auto" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value:
                        "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                        encodeURIComponent(
                          encodeURIComponent(_vm.profile.urlProfile)
                        ),
                      expression:
                        "\n                `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(\n                  encodeURIComponent(profile.urlProfile),\n                )}`\n              "
                    }
                  ],
                  staticClass: "uk-border-circle",
                  staticStyle: { width: "54px", height: "54px" },
                  attrs: {
                    width: "64",
                    height: "64",
                    "data-src": "holder.js/64x64",
                    "data-holder-rendered": "true"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "uk-width-expand" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "uk-card-title uk-margin-remove-bottom uk-margin-remove-top"
                  },
                  [_vm._v(_vm._s(_vm.profile.nickName))]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-group" }, [_vm._v("Contact Customers")]),
      _vm._v(" "),
      _c(
        "scroll-box",
        {
          staticClass: "contact-showScoll",
          style: {
            overflowY: _vm.searchCustomers.length > 8 ? "scroll" : "none"
          },
          on: { "on-scroll-bottom": _vm.loadMoreCustomer }
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.customersLoading,
                  expression: "customersLoading"
                }
              ],
              staticClass: "list-group",
              class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
              attrs: { id: "listContact" }
            },
            _vm._l(_vm.searchCustomers, function(item) {
              return _c(
                "li",
                {
                  key: item.custId,
                  staticClass: "list-group-item",
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch(
                        "contact/setActiveContactCustumer",
                        item
                      )
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "uk-grid-small uk-flex-middle",
                      attrs: { "uk-grid": "" }
                    },
                    [
                      _c("div", { staticClass: "uk-width-auto" }, [
                        _c("a", { attrs: { href: "#" } }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value:
                                  "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                                  encodeURIComponent(
                                    encodeURIComponent(item.custImage)
                                  ),
                                expression:
                                  "\n                  `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(\n                    encodeURIComponent(item.custImage),\n                  )}`\n                "
                              }
                            ],
                            staticClass: "uk-border-circle",
                            staticStyle: { width: "54px", height: "54px" },
                            attrs: {
                              width: "64",
                              height: "64",
                              "data-src": "holder.js/64x64",
                              "data-holder-rendered": "true"
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "uk-width-expand" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "uk-margin-remove-bottom uk-margin-remove-top"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.custNameNew == ""
                                  ? item.custName
                                  : item.custNameNew
                              )
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4074abc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4074abc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListContact.vue
// module id = null
// module chunks = 